var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('button',{staticClass:"close",class:{ 'close-inverse': _vm.inverse },on:{"click":_vm.closeModal}},[_c('Icon',{attrs:{"icon":"close","color":"white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }